module.exports = __webpack_public_path__ + "static/media/nav_card_icon_3.f7fe232a.svg";